

export class UserFormatError extends Error {
    //
    // Error code matches with backend exception
    //
    static errorCode: string = "Bad User Format";

    constructor(msg: string) {
        super(msg);

        Object.setPrototypeOf(this, UserFormatError.prototype);
    }
}